<template>
  <div class="recruitement-candidate-filter">
    <div v-if="$q.screen.gt.xs" class="desktop-filters">
      <slot v-if="shouldDisplayfilters" name="filters" />
      <div class="text-left">
        <QBtn
          flat
          no-caps
          :ripple="false"
          :label="shouldDisplayfilters ? $t('ETAB.PAGES.CANDIDATE.FILTERS.@HIDE_FILTERS') : $t('ETAB.PAGES.CANDIDATE.FILTERS.@SHOW_FILTERS')"
          :icon="!shouldDisplayfilters ? 'icon-extra-filter' : 'expand_less'"
          @click="toggleFilters"
        />
      </div>
    </div>
    <div v-if="!$q.screen.gt.xs">
      <QBtn flat :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@SHOW_FILTERS')" icon="icon-extra-filter" color="primary" @click="open('right')" />
      <ExtracadabraModal
        v-model:opened="isFilterOpen"
        :quasar-props="{ position: 'top' }"
        :header="{
          title: $t('ETAB.PAGES.CANDIDATE.FILTERS.@FILTERS_TITLE'),
        }"
        @hide="$emit('applyFilters')"
      >
        <template #body>
          <slot name="filters" />
          <div class="q-mt-lg text-center">
            <QBtn v-close-popup :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@SHOW_RESULTS')" color="secondary" @click="$emit('applyFilters')" />
          </div>
        </template>
      </ExtracadabraModal>
    </div>
    <div v-if="!shouldDisplayfilters || !$q.screen.gt.xs" class="filters-chips">
      <div v-if="filters.getLocations()">
        <QChip
          v-for="(location, index) in filters.getLocations()"
          :key="index"
          :label="location.getCity()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(location, filters[IRecruitmentCandidatesFilters.locations])"
        />
      </div>
      <div v-if="filters.getLanguages()">
        <QChip
          v-for="(language, index) in filters.getLanguages()"
          :key="index"
          :label="language.getLabel()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(language, filters[IRecruitmentCandidatesFilters.languages])"
        />
      </div>
      <div v-if="filters.getExperiences()">
        <QChip
          v-for="(xp, index) in filters.getExperiences()"
          :key="index"
          :label="xp.getLabel()"
          color="primary"
          text-color="white"
          removable
          @remove="remove(xp, filters[IRecruitmentCandidatesFilters.workExperiences])"
        />
      </div>
      <div v-if="filters.hasRecommendation()">
        <QChip
          :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_RECOMMENDATION')"
          color="primary"
          text-color="white"
          removable
          @remove="resetToggleFilter(IRecruitmentCandidatesFilters.hasRecommendation)"
        />
      </div>
      <div v-if="filters.hasVehicle()">
        <QChip
          :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_VEHICLE')"
          color="primary"
          text-color="white"
          removable
          @remove="resetToggleFilter(IRecruitmentCandidatesFilters.hasVehicle)"
        />
      </div>
      <div v-if="filters.hasAlreadyWorkedIn()">
        <QChip
          :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@HAS_ALREADY_WORKED_IN_CHIP', { category: recruitment.getEtabFamilyGroupName() })"
          color="primary"
          text-color="white"
          removable
          @remove="resetToggleFilter(IRecruitmentCandidatesFilters.alreadyWorkedIn)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapStores } from "pinia";
  import { JavascriptHelpers } from "@core/helpers";
  import { RecruitmentCandidatesFiltersModel, IRecruitmentCandidatesFilters } from "@core/models";
  import { ETAB_ROUTES } from "@etab/config";
  import { ExtracadabraModal } from "@core/components/modals";
  import { useProfileStore } from "@etab/stores/profile";
  import { useSessionStore } from "@etab/stores/session";
  import { useRecruitmentStore } from "@etab/stores/recruitment";

  import {
    ACTION_SESSION_HIDE_FILTERS,
    ACTION_SESSION_SHOW_FILTERS,
    GETTER_RECRUITMENT_GET_CURRENT,
    GETTER_SESSION_SHOULD_DISPLAY_FILTERS,
    GETTER_PROFILE_GET,
  } from "@etab/stores/types"; // pinia

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      filters: {
        type: Object,
        default: () => new RecruitmentCandidatesFiltersModel(),
      },
    },
    emits: ["applyFilters", "searchLocation"],
    data() {
      return {
        locations: undefined,
        languages: undefined,
        experiences: undefined,
        alreadyWorkedIn: 0,
        hasVehicle: 0,
        hasRecommendation: 0,
        activateLoading: false,
        position: "",
        isFilterOpen: false,
        filteredLocationOptions: [],
        displayFilter: true,
      };
    },
    computed: {
      ...mapStores(useProfileStore, useSessionStore, useRecruitmentStore),
      etabProfile() {
        return this.profileStore[GETTER_PROFILE_GET];
      },
      recruitment() {
        return this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
      },
      shouldDisplayfilters() {
        return this.sessionStore[GETTER_SESSION_SHOULD_DISPLAY_FILTERS];
      },
    },
    created() {
      this.IRecruitmentCandidatesFilters = IRecruitmentCandidatesFilters;
    },
    methods: {
      open(position) {
        this.position = position;
        this.isFilterOpen = true;
      },
      setCities(val) {
        this.$emit("searchLocation", val);
      },
      capitalizeFirstLetterOption(option) {
        return JavascriptHelpers.capitalizeFirstLetter(option);
      },
      remove(selected, filters) {
        this.filters.removeFilters(selected, filters);
        this.$emit("applyFilters");
      },
      resetToggleFilter(toggle) {
        this.filters.resetToggleFilters(toggle);
        this.$emit("applyFilters");
      },
      toggleFilters() {
        if (this.shouldDisplayfilters === true) {
          this.sessionStore[ACTION_SESSION_HIDE_FILTERS]();
        } else {
          this.sessionStore[ACTION_SESSION_SHOW_FILTERS]();
        }
      },
      goToSubscription() {
        this.$router.push({ name: ETAB_ROUTES.subscription.name }).catch((suppressedError) => {});
      },
    },
  };
</script>
<style lang="scss" scoped>
  .recruitement-candidate-filter {
    .desktop-filters {
      background-color: #ffffff;
      padding: 15px;
    }
    .filters-chips {
      display: flex;
      flex-direction: column;
      justify-content: center;

      > div {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
</style>
